// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.root-190 {
  font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  font-weight: 400;
  display: inline-block;
  background: rgb(255, 255, 255);
  position: relative;
  min-width: 100%;
  vertical-align: top;
  height: 25px;
  line-height: 25px;
  white-space: nowrap;
  box-sizing: content-box;
  padding-bottom: 1px;
  padding-top: 16px;
  border-bottom: 1px solid rgb(237, 235, 233);
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
}
.container {
  width: 1000px;
  height: 350px;
  margin: 50px;
  margin-top: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: black;
}

.parent {
  position: relative;
  top: 0;
  left: 0;
  float: left;
}
.msteamsIcon {
  position: relative;
  top: 10;
  left: 0;
  height: 70px;
  width: 70px;
  margin-top: 20px;
  float: left;
  margin-left: 323px;

}
.disablePopupImg {
  position: absolute;
  top: 200px;
  left: 20px;
  height: 250px;
  width: 770px;
}

.loader{
  width: 500px;
}

.progressBar{
  margin-top:40;
  margin-left: 270px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;AACA;EACE,4IAA4I;EAC5I,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,OAAO;EACP,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,kBAAkB;;AAEpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n.root-190 {\n  font-family: \"Segoe UI\", \"Segoe UI Web (West European)\", \"Segoe UI\", -apple-system, BlinkMacSystemFont, Roboto, \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-size: 12px;\n  font-weight: 400;\n  display: inline-block;\n  background: rgb(255, 255, 255);\n  position: relative;\n  min-width: 100%;\n  vertical-align: top;\n  height: 25px;\n  line-height: 25px;\n  white-space: nowrap;\n  box-sizing: content-box;\n  padding-bottom: 1px;\n  padding-top: 16px;\n  border-bottom: 1px solid rgb(237, 235, 233);\n  cursor: default;\n  user-select: none;\n}\n.container {\n  width: 1000px;\n  height: 350px;\n  margin: 50px;\n  margin-top: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.circle {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: black;\n}\n\n.parent {\n  position: relative;\n  top: 0;\n  left: 0;\n  float: left;\n}\n.msteamsIcon {\n  position: relative;\n  top: 10;\n  left: 0;\n  height: 70px;\n  width: 70px;\n  margin-top: 20px;\n  float: left;\n  margin-left: 323px;\n\n}\n.disablePopupImg {\n  position: absolute;\n  top: 200px;\n  left: 20px;\n  height: 250px;\n  width: 770px;\n}\n\n.loader{\n  width: 500px;\n}\n\n.progressBar{\n  margin-top:40;\n  margin-left: 270px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
